import React from "react";

import { Divider } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { useSelector } from "react-redux";

import {
  BusinessField,
  SundryTemplateLabelSelectorField,
} from "components/Form/Fields";
import {
  CheckBox,
  Input,
  SelectField,
  withNamespace,
} from "components/Form/FormikControls";
import { GstMethodOptions } from "components/Sundry/Form/SundryPricingForm";

import { BaseTaxTypeOptions } from "constants/billing";
import { businessRoleFilterOptions } from "constants/businesses";
import { sundryPartyTypeOptions } from "constants/sundryTemplates";

import { selectMyLedgerAccountOptionsForLedgerEntryForm } from "selectors";

interface SundryTemplateFormProps {
  namespace?: string;
}

export function SundryTemplateForm(props: SundryTemplateFormProps) {
  const { namespace: ns = "" } = props;

  const ledgerAccountOptions: SelectFieldOption[] = useSelector(
    selectMyLedgerAccountOptionsForLedgerEntryForm,
  );
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Input name={withNamespace(ns, "name")} label="Name" required />
      </Grid>

      <Grid item xs={12}>
        <Input
          name={withNamespace(ns, "note")}
          label="Note"
          required
          tooltip="Default note to include on the line item for this sundry."
        />
      </Grid>

      <Grid item xs={12}>
        <CheckBox
          tooltip="Show this template in the Sundry quick select menu, this option will only be shown to documents relevant to the paid to type and paid from type Eg. Selectable on an invoice/RCTI if the paid to or paid from type is invoice/RCTI"
          label="Add this template to compatible Sundry quick select items"
          dataTour="quickSelectSundryTemplate"
          name="quickSelect"
        />
      </Grid>

      <Grid item xs={6} container>
        <h2>Paid From</h2>
        <Grid item xs={12}>
          <SelectField
            required
            name={withNamespace(ns, "paidFromType")}
            label="Output"
            options={sundryPartyTypeOptions}
            menuPortalTarget={document.body}
          />
        </Grid>
        <Grid item xs={12}>
          <SelectField
            name={withNamespace(ns, "paidFromSearchFilter")}
            label="Search Filter"
            options={businessRoleFilterOptions}
            menuPortalTarget={document.body}
            isClearable
          />
        </Grid>
        <Grid item xs={12}>
          <BusinessField
            label="Business"
            name={withNamespace(ns, "paidFromBusinessId")}
          />
        </Grid>
      </Grid>

      <Grid item xs={6} container>
        <h2>Paid To</h2>
        <Grid item xs={12}>
          <SelectField
            name={withNamespace(ns, "paidToType")}
            label="Output"
            options={sundryPartyTypeOptions}
            menuPortalTarget={document.body}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <SelectField
            name={withNamespace(ns, "paidToSearchFilter")}
            label="Search Filter"
            options={businessRoleFilterOptions}
            menuPortalTarget={document.body}
            isClearable
          />
        </Grid>
        <Grid item xs={12}>
          <BusinessField
            label="Business"
            name={withNamespace(ns, "paidToBusinessId")}
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={6}>
        <SelectField
          name={withNamespace(ns, "glCode")}
          label="Account / GL Code"
          options={ledgerAccountOptions}
          menuPortalTarget={document.body}
        />
      </Grid>
      <Grid item xs={6}>
        <SelectField
          name={withNamespace(ns, "taxType")}
          label="Tax Type"
          options={BaseTaxTypeOptions}
          menuPortalTarget={document.body}
          required
        />
      </Grid>
      <Grid item xs={6}>
        <SelectField
          name={withNamespace(ns, "gstMethod")}
          label="GST Method"
          options={GstMethodOptions}
          menuPortalTarget={document.body}
          required
        />
      </Grid>
      <Grid item xs={6}>
        <SundryTemplateLabelSelectorField label="Labels" name="labels" />
      </Grid>
    </Grid>
  );
}
